import { call, put, select, takeEvery } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { SELECT_GROUP } from 'modules/groups/actionTypes';
import { getBaseParameters } from 'modules/selfServices/selectors/config';
import { fetchVehicleCheckModels } from 'modules/vehicleCheckModels/actions';

import { checkSelectedGroup } from './extras.dashboard';

const refreshDashboard = (group = false) =>
  function* refresh() {
    const source = group ? 'group-dashboard' : 'dealer-dashboard';
    const params = yield select(state => getBaseParameters(state, group));
    if (params.groupId || params.dealerId) {
      yield put(fetchVehicleCheckModels(params, { source }));
    }
  };

function* initializeDealerDashboard() {
  const refreshFn = refreshDashboard();
  yield call(refreshFn);
  yield takeEvery(SELECT_DEALER, refreshFn);
}

function* initializeGroupDashboard() {
  const refreshFn = refreshDashboard(true);
  yield call(checkSelectedGroup);
  yield call(refreshFn);
  yield takeEvery([SELECT_DEALER, SELECT_GROUP], refreshFn);
}

export default function* VehiclesCheckDashboardSaga() {
  yield scopeToPage([PATH.GROUP_VEHICLE_CHECK_MODEL_DASHBOARD], initializeGroupDashboard);
  yield scopeToPage([PATH.DEALER_VEHICLE_CHECK_MODEL_DASHBOARD], initializeDealerDashboard);
}
